import styled, { css } from 'styled-components';
import { colors } from '@/globalStyles';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const ModalBodyStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 45px;
  width: 300px;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          width: 100vw;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const InputStyled = styled.input`
  width: 100%;
  height: 40px;
  text-align: center;
  border: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.35);
  background-color: ${colors.backgroundInput};
  border-bottom: 2px solid ${props => (props.$error ? 'red' : colors.primary)};
  outline: none;

  font-family: Lato;
  font-size: 14px;
  color: ${colors.black};

  &:disabled {
    pointer-events: none;
    filter: grayscale(100%);
    opacity: 0.7;
  }
`;
